import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface ModalStateInterface {
  callMeModal: {
    open: boolean;
    action?: () => void;
  },
  termsAndConditionsModal: {
    open: boolean;
  },
  contactModal: {
    open: boolean;
  },
  addressModal: {
    open: boolean;
    type?: 'insuredPerson' | 'contractor' | 'delivery';
  },
  termsAndConditionsAdditionalModal: {
    open: boolean;
    offerId?: string;
  },
}

// ============ INIT STATE ============

const initialState: ModalStateInterface = {
  callMeModal: {
    open: false,
  },
  termsAndConditionsModal: {
    open: false,
  },
  contactModal: {
    open: false,
  },
  addressModal: {
    open: false,
  },
  termsAndConditionsAdditionalModal: {
    open: false,
    offerId: undefined,
  },
};

// ========= SLICE ==========

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openCallMeModal: (state: ModalStateInterface) => {
      state.callMeModal.open = true;
    },
    closeCallMeModal: (state: ModalStateInterface) => {
      state.callMeModal.open = false;
      state.callMeModal.action = undefined;
    },
    openTermsAndConditionsModal: (state: ModalStateInterface) => {
      state.termsAndConditionsModal.open = true;
    },
    closeTermsAndConditionsModal: (state: ModalStateInterface) => {
      state.termsAndConditionsModal.open = false;
    },
    openContactModal: (state: ModalStateInterface) => {
      state.contactModal.open = true;
    },
    closeContactModal: (state: ModalStateInterface) => {
      state.contactModal.open = false;
    },
    openAddressModal: (state: ModalStateInterface, action: PayloadAction<{ type: 'insuredPerson' | 'contractor' | 'delivery' }>) => {
      state.addressModal.open = true;
      state.addressModal.type = action.payload.type;
    },
    closeAddressModal: (state: ModalStateInterface) => {
      state.addressModal.open = false;
    },
    openCallMeModalWithAction: (state: ModalStateInterface, action: PayloadAction<() => void>) => {
      state.callMeModal.open = true;
      state.callMeModal.action = action.payload;
    },
    openTermsAndConditionsAdditionalModal: (state: ModalStateInterface, action: PayloadAction<{ offerId: string }>) => {
      if (!state.termsAndConditionsAdditionalModal) {
        state.termsAndConditionsAdditionalModal = { open: false, offerId: undefined };
      }
      state.termsAndConditionsAdditionalModal.open = true;
      state.termsAndConditionsAdditionalModal.offerId = action.payload.offerId;
    },
    closeTermsAndConditionsAdditionalModal: (state: ModalStateInterface) => {
      if (!state.termsAndConditionsAdditionalModal) {
        state.termsAndConditionsAdditionalModal = { open: false, offerId: undefined };
      }
      state.termsAndConditionsAdditionalModal.open = false;
      state.termsAndConditionsAdditionalModal.offerId = undefined;
    },
  }
})

export const { openCallMeModal, openCallMeModalWithAction, closeCallMeModal, openTermsAndConditionsModal, closeTermsAndConditionsModal, openContactModal, closeContactModal, openAddressModal, closeAddressModal, openTermsAndConditionsAdditionalModal, closeTermsAndConditionsAdditionalModal } = modalSlice.actions;

export default modalSlice.reducer;